import type {
  PickPageCollectionsQueryResponse,
  PickPageCollectionsQueryVariables,
} from '~/api/shopify/queries/pickPageCollections.generated';
import type { PickPageCollectionNodeFragment } from '~/api/shopify/fragments/pickPageCollection.generated';
import type { IPickPageSource, IPickPageSourceParams } from '../../types';

import {
  PICK_PAGE_SORT_KEY,
  PICK_PAGE_IS_SORT_REVERSED,
  PICK_PAGE_PAGE_SIZE,
} from '../../constants';
import { PickPageCollectionsDocument } from '~/api/shopify/queries/pickPageCollections.generated';
import { toPickPageItemFromCollection, toPickPageSearchQuery } from '../../utils';
import { usePickPageConnectionSource } from './usePickPageConnectionSource';

export const usePickPageCollectionSource = ({
  searchValue,
  isEnabled,
  templateAssetKeys,
}: IPickPageSourceParams): IPickPageSource =>
  usePickPageConnectionSource<
    PickPageCollectionsQueryResponse,
    PickPageCollectionsQueryVariables,
    PickPageCollectionNodeFragment
  >({
    queryKey: 'pick-page-collection-infinity',
    document: PickPageCollectionsDocument,
    toVariables: (after?: string) => ({
      first: PICK_PAGE_PAGE_SIZE,
      query: toPickPageSearchQuery(searchValue),
      sortKey: PICK_PAGE_SORT_KEY,
      reverse: PICK_PAGE_IS_SORT_REVERSED,
      after,
    }),
    searchValue,
    isEnabled,
    templateAssetKeys,
    toConnection: (response) => response.collections,
    toItem: toPickPageItemFromCollection,
  });
